import { useEffect, useState } from 'react';

// graphql
import { CashTransferStatus, PageInfo, useApt_PlayerBalanceAdditionsQuery } from '@/generated/graphql';

// interfaces
import {
  IPlayerAdditionTransactionTable_AD,
  IPlayerBalanceAddition,
  IPlayerBalanceAdditionQueryVariable,
  mapGQLPlayerBalanceAddition,
} from '@/shared/interfaces';

// helpers
import { formatNumber } from '@/shared/constants';

// components
import { TablePlayerBalanceAdditions } from './table';

export const PlayerAdditions = () => {
  const [additions, setAdditions] = useState<IPlayerAdditionTransactionTable_AD[]>([]);

  const [queryVariable, setQueryVariable] = useState<IPlayerBalanceAdditionQueryVariable>({
    first: 25,
    filterBy: {
      status: [CashTransferStatus.VirifiedByCashier],
    },
  });
  const [additionPageInfo, setAdditionPageInfo] = useState<PageInfo>();
  const [additionTotalCount, setAdditionTotalCount] = useState<number>(0);

  const {
    data: additionData,
    loading: additionLoading,
    error: additionError,
    refetch: additionRefetch,
  } = useApt_PlayerBalanceAdditionsQuery({
    fetchPolicy: 'network-only',
    variables: queryVariable,
    pollInterval: 5000,
  });

  useEffect(() => {
    if (additionData && !additionLoading && !additionError) {
      const mapPlayerBalanceAdditions: IPlayerBalanceAddition[] = additionData.playerBalanceAdditions.nodes.map((playerBalanceAddition) =>
        mapGQLPlayerBalanceAddition(playerBalanceAddition),
      );

      const tableData = mapPlayerBalanceAdditions.map((x) => ({
        id: x.id,
        amountDisplay: formatNumber(x.amount),
        referenceId: x.referenceId,
        transactionType: x.transactionType,
        createdAt: x.createdAt,
        status: x.status,

        playerName: `${x.player.firstName} ${x.player.lastName}`,
        cashierName: `${x.cashier.firstName} ${x.cashier.lastName}`,
        auditorId: x.auditor.id,
        paymentGatewayNumber: `${x.paymentGateway.accountNumber} (${x.paymentGateway.name})`,
        notes: x.notes,
      }));

      if (additions.length === 0 && tableData.length > 0) {
        setAdditions(tableData);
        setAdditionPageInfo(additionData.playerBalanceAdditions.pageInfo);
        setAdditionTotalCount(additionData.playerBalanceAdditions.totalCount);
      } else {
        let allStatusMatch = true;

        additions.forEach((addition) => {
          const found = tableData.find((x) => x.id === addition.id);

          if (found && (found.status !== addition.status || (found.auditorId.length > 2 && addition.auditorId.length === 0))) {
            allStatusMatch = false;
          }
        });

        if (tableData.length !== additions.length || !allStatusMatch) {
          setAdditions(() => tableData);
          setAdditionPageInfo(additionData.playerBalanceAdditions.pageInfo);
          setAdditionTotalCount(additionData.playerBalanceAdditions.totalCount);
        }
      }
    }
  }, [additionLoading, additionError, additionData]);

  return (
    <>
      <TablePlayerBalanceAdditions
        rows={additions}
        setPlayerBalanceAdditionQueryVariable={setQueryVariable}
        playerBalanceAdditionQueryVariable={queryVariable}
        totalCount={additionTotalCount}
        pageInfo={additionPageInfo}
        getPlayerBalanceAdditionLoading={additionLoading}
        refetch={additionRefetch}
      />
    </>
  );
};
